import styled from 'styled-components';
import PageActionHeader from './components/PageActionHeader';
import PausedNotificationsToast from './one-click-trade/PausedNotificationsToast';

export default function UnifiedRfqActionHeader() {
  return (
    <div css="position: relative;">
      <ToastContainer>
        <PausedNotificationsToast />
      </ToastContainer>
      <PageActionHeader />
    </div>
  );
}

const ToastContainer = styled.div`
  position: absolute;
  top: 88px;
  z-index: 12;
  left: 50%;
  transform: translate(-50%, -50%);
`;
